import { Trash } from "lucide-react";
import { useState, useEffect, useRef } from "react";

const EditableText = ({
  value,
  onChange,
  className = "",
  placeholder = "Inserisci il testo",
  prefix = ""
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(value || "");
  const inputRef = useRef(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  useEffect(() => {
    setText(value || "");
  }, [value]);

  const handleBlur = () => {
    setIsEditing(false);
    if (text !== value) {
      onChange(text);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setIsEditing(false);
      if (text !== value) {
        onChange(text);
      }
    }
  };

  if (isEditing) {
    return (
      <div className={className}>
        {prefix && <span className="px-1">{prefix}</span>}
        <input
          ref={inputRef}
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          className="border-b border-gray-600 outline-none w-full"
          placeholder={placeholder}
        />
      </div>
    );
  }

  return (
    <div
      className={`${className} cursor-pointer hover:bg-gray-50 `}
      onClick={() => setIsEditing(true)}
    >
      {prefix}{value || <span className="italic text-gray-400">{placeholder}</span>}
    </div>
  );
};

export default EditableText;